import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useProducts } from "../hooks/useProducts";
import { playSound } from "../utils/productUtils";
import powederImage from "../../src/assets/powered in b2r6nnies.png";
import logoImage from "../../src/assets/logo.png";
import "../styles/MobileRetroLayout.css";
import { useSettings } from "../hooks/useSettings";

export default function MobileLayout() {
  const API_BASE_URL = process.env.REACT_APP_API_URL
  const { categories } = useProducts();
  const { settings, loading } = useSettings();
  const [backgroundImage, setBackgroundImage] = useState(null);



 useEffect(() => {
    if (!loading && settings?.mobileBackgroundPath) {
      const imageUrl = `${API_BASE_URL}${settings.mobileBackgroundPath}`;
      setBackgroundImage(imageUrl);
    }
  }, [settings, loading]);


  return (
    <div className="mobile-retro-layout"
     style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
      }}>
      <div className="logo-container">
        <img src={logoImage} alt="Logo MegaHortz" className="logo" />
      </div>

      <div className="categories-grid">
        {categories?.map((category) => (
          <Link
            key={category.id}
            to={`/${category.name.toLowerCase().replace(/\s+/g, "-")}`}
            className="category-button"
            onClick={playSound}
          >
            {category.name.toUpperCase()}
          </Link>
        ))}
      </div>

      <footer className="mobile-footer">
        <div className="logo-container">
          <img
            src={powederImage}
            alt="Powdered in Baronnies"
            className="logo"
          />
        </div>
      </footer>
    </div>
  );
}
